<template>
  <div v-if="exam" id="ExamInfo" class="wrap">
    <v-app-bar class="grey lighten-3 desktopHeader--remove hidden-md-and-up" fixed elevate-on-scroll>
      <span class="title light-blue--text text--darken-3 ">{{exam.exam_type }}  </span>
      <v-spacer></v-spacer>
      <RemoveExam :exam="exam"/>
    </v-app-bar>
    <div class="maxContainer">
      <div class="HealthcareHours__cover offset-md-3 col-md-6 offset-sm-2 col-sm-8 ">

        <div @click="back" class="headerFake__back">
          <a class="headerFake__backLink">
            <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
            <span class="headerFake__backText">Back</span>
          </a>
        </div>
        <!-- Exam Status -->
        <v-container px-0 pt-0 pb-5 >
          <v-layout align-center class="hidden-sm-and-down px-1 mt-10 mb-3">
            <span class="title light-blue--text text--darken-3 ">{{exam.exam_type }}  </span>
            <v-spacer></v-spacer>
            <RemoveExam :exam="exam"/>
          </v-layout>
          <v-card class="mx-1 mb-5 pb-2" style="borderRadius:5px" id="buttonShadow">
            <v-card-title @click="editExamStatusDialog = true" class="pa-0">
              <v-layout class="grey lighten-3" align-center>
                <v-layout  class="grey lighten-3" py-2>
                  <p class="subtitle-1 text--primary ml-2 mb-0 font-weight-light">Exam Status</p>
                </v-layout>
                <v-spacer></v-spacer>
                <v-icon class="mr-2">mdi-pencil</v-icon>
              </v-layout>
            </v-card-title>
            <v-card-text class="pb-0 pt-2 pl-0 ">
              <v-layout justify-center >
              <span class="title"><span  v-bind:class="{ 'amber--text text--darken-3' : exam.examStatus === 'Scheduled', 'green--text' : exam.examStatus === 'Completed'}">{{exam.examStatus | capitalizeString}}</span></span>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- Update Exam Status Dialog -->
        <v-dialog
          v-model="editExamStatusDialog"
          style="zIndex:40001"
          max-width="400"
          persistent
          >
          <v-card style="borderRadius:5px">
            <v-card-title class="subheading grey lighten-2 text-xs-center">Update Exam Status</v-card-title>
            <v-card-text class="text-xs-justify mt-4 pb-3 px-2"   >
            <v-flex xs12>
              <v-select
                :items="['Scheduled', 'Completed',]"
                v-model="exam.examStatus"
                outlined
                hide-details
                >
              </v-select>
            </v-flex>
            </v-card-text>
            <v-card-actions>



              <v-btn
                color="green"
                block
                large
                dark
                class="elevation-0"
                @click="saveStatus()"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Exam Date -->
        <v-container px-0 pt-0 pb-5 >
          <!-- Scheduled Exam Date -->
          <v-card v-if="exam.examStatus === 'Scheduled' " class="mx-1 mb-5 pb-2" style="borderRadius:5px" id="buttonShadow">
            <v-card-title @click="editExamDateDialog = true" class="pa-0">
              <v-layout class="grey lighten-3" align-center>
                <v-layout  class="grey lighten-3" py-2>
                  <p class="subtitle-1 text--primary ml-2 mb-0 font-weight-light">Exam Date</p>
                </v-layout>
                <v-spacer></v-spacer>

                  <v-icon class="mr-2">mdi-pencil</v-icon>
              </v-layout>
            </v-card-title>

            <v-card-text class="mt-4 pb-2">
              <v-layout column align-center justify-center>
                <span class="title font-weight-regular"><span >{{exam.date | removeTimeFromDate | moment(" MM/DD/YYYY")}}</span></span>
                <span class=" grey--text">{{exam.date| moment("from", "now")}}</span>
              </v-layout>
            </v-card-text>
          </v-card>

          <!-- Completed Exam Date -->
          <v-card v-if="exam.examStatus === 'Completed' "  class="mx-1 mb-5 pb-2" style="borderRadius:5px" id="buttonShadow">
            <v-card-title @click="editExamDateDialog = true" class="pa-0">
              <v-layout class="grey lighten-3" align-center>
                <v-layout  class="grey lighten-3" py-2>
                  <p class="subtitle-1 text--primary ml-2 mb-0 font-weight-light">Completed Date</p>
                </v-layout>
                <v-spacer></v-spacer>

                  <v-icon class="mr-2">mdi-pencil</v-icon>
              </v-layout>

            </v-card-title>

            <v-card-text class="mt-4 pb-2">
              <v-layout column align-center justify-center>
                <span class="green--text title font-weight-regular"><span >{{exam.date | removeTimeFromDate | moment(" MM/DD/YYYY")}}</span></span>
              </v-layout>
            </v-card-text>

          </v-card>

          <!-- Edit Exam Date Dialog -->
          <v-dialog
            v-model="editExamDateDialog"
            style="zIndex:40001"
            max-width="400"
            persistent
            >
            <v-card style="borderRadius:10px">
              <v-card-title class="title grey lighten-2 text-xs-center">Change Exam Date</v-card-title>

              <v-date-picker header-color="grey lighten-2" no-title v-model="exam.date" full-width class="elevation-0" @input="menu2 = false"></v-date-picker>
            <v-card-actions>
                <v-btn @click="editExamDate" block  round color="green" dark>Save</v-btn>
            </v-card-actions>


            </v-card>
          </v-dialog>

        </v-container>

        <!-- Exam Scores -->
        <v-container v-if="exam.examStatus === 'Completed'" px-0 pt-0 pb-5 style="marginBottom:60px">
          <!-- Add Scores Button -->
          <v-layout v-if="exam.exam_scores === false && exam.exam_type !== 'CASper' && exam.exam_type !== 'PA-CAT'" justify-center>
            <v-btn  color="green" class="elevation-5" dark  large @click="showAddExamScoresPage(exam.id)" >Add Your Scores</v-btn>
          </v-layout>
          <!-- Exam Scores -->
          <v-card v-if="exam.exam_scores === true " class="mx-1 mb-5 pb-2" style="borderRadius:5px" id="buttonShadow">
              <v-card-title @click="editExamScoresPage(exam.id)" class="pa-0">
              <v-layout class="grey lighten-3" align-center>
                <v-layout  class="grey lighten-3" py-2>
                  <p class="subtitle-1 text--primary ml-2 mb-0 font-weight-light">Exam Scores</p>
                </v-layout>
                <v-spacer></v-spacer>

                  <v-icon class="mr-2">mdi-pencil</v-icon>
              </v-layout>
            </v-card-title>

            <v-card-text class="pt-2">

            <v-container v-if="exam.exam_type === 'GRE' " class="pt-1">
                <v-layout column v-if="exam.gre_combined_score || exam.gre_verbal_reasoning_score || exam.gre_analytical_writing_score || exam.gre_quantitative_reasoning_score  ">
                  <v-text-field
                    v-model="exam.gre_combined_score"
                    label="Combined Score"
                    color="black"
                    readonly
                  ></v-text-field>

                  <v-text-field
                    v-model="exam.gre_verbal_reasoning_score"
                    label="Verbal Reasoning Score"
                    color="black"
                    readonly
                  ></v-text-field>



                  <v-text-field
                    v-model="exam.gre_analytical_writing_score"
                    label="Analytical Writing Score"
                    color="black"
                    readonly
                  ></v-text-field>


                  <v-text-field
                    v-model="exam.gre_quantitative_reasoning_score"
                    label="Quantitative Reasoning Score"
                    color="black"
                    readonly
                  ></v-text-field>
                </v-layout>




              <v-layout column v-if="exam.gre_verbal_percentile_score !== '' || exam.gre_quantitative_percentile_score !== '' || exam.gre_analytical_percentile_score !== '' || exam.gre_combined_percentile_score !== ''">
                  <v-subheader class=" font-weight-medium pl-0 pb-0  mb-0 blue--text text--darken-3">Percentile Scores</v-subheader>
                  <v-text-field
                    v-model="exam.gre_combined_percentile_score"
                    label="Combined % "
                    class="mt-0 pt-1"
                    color="black"
                    readonly
                  ></v-text-field>
                  <v-text-field
                    v-model="exam.gre_verbal_percentile_score"
                    label="Verbal % "
                    class="mt-0 pt-1"
                    color="black"
                    readonly
                  ></v-text-field>


                  <v-text-field
                    v-model="exam.gre_quantitative_percentile_score"
                    label="Quantitative % "
                    class="mt-0 pt-1"
                    color="black"
                    readonly
                  ></v-text-field>


                  <v-text-field
                    v-model="exam.gre_analytical_percentile_score"
                    label="Analytical Writing % "
                    class="mt-0 pt-1"
                    color="black"
                    readonly
                  ></v-text-field>
              </v-layout>
            </v-container>

            <v-container v-if="exam.exam_type === 'MCAT' " class="pt-1 pb-0">
              <v-text-field
                  v-model="exam.mcat_total_score"
                  label="MCAT Total Score"
                  color="black"
                  readonly
                ></v-text-field>
            </v-container>

            <v-container v-if="exam.exam_type === 'TOEFL iBT' " class="pt-1 pb-0">
                  <v-text-field
                  v-model="exam.toeflIbt_total_score"
                  label="Total Score"
                  color="black"
                  readonly
                ></v-text-field>

                <v-text-field
                  v-model="exam.toeflIbt_reading_score"
                  label="Reading Score"
                  color="black"
                  readonly
                ></v-text-field>


                <v-text-field
                  v-model="exam.toeflIbt_writing_score"
                  label="Writing Score"
                  color="black"
                  readonly
                ></v-text-field>


                <v-text-field
                  v-model="exam.toeflIbt_listening_score"
                  label="Listening Score"
                  color="black"
                  readonly
                ></v-text-field>


                <v-text-field
                  v-model="exam.toeflIbt_speaking_score"
                  label="Speaking Score"
                  color="black"
                  readonly
                ></v-text-field>
            </v-container>

            <v-container v-if="exam.exam_type === 'TOEFL PBT' " class="pt-1 pb-0">
              <v-text-field
                  v-model="exam.toeflPbt_total_score"
                  label="Total Score"
                  color="black"
                  readonly
                ></v-text-field>

                <v-text-field
                  v-model="exam.toeflPbt_reading_score"
                  label="Reading Score"
                  color="black"
                  readonly
                ></v-text-field>


                <v-text-field
                  v-model="exam.toeflPbt_writing_score"
                  label="Writing Score"
                  color="black"
                  readonly
                ></v-text-field>


                <v-text-field
                  v-model="exam.toeflPbt_listening_score"
                  label="Listening Score"
                  color="black"
                  readonly
                ></v-text-field>
            </v-container>

            <v-container v-if="exam.exam_type === 'PTE Academic' " class="pt-1 pb-0">
              <v-text-field
                  v-model="exam.pteAcademic_overall_score"
                  label="Overall Score"
                  color="black"
                  readonly
                ></v-text-field>
            </v-container>

              <v-container v-if="exam.exam_type === 'IELTS' " class="pt-1 pb-0">
              <v-text-field
                  v-model="exam.ielts_overall_score"
                  label="Overall Score"
                  color="black"
                  readonly
                ></v-text-field>
            </v-container>

            <v-container v-if="exam.exam_type === 'MELAB' " class="pt-1 pb-0">
              <v-text-field
                  v-model="exam.melab_overall_score"
                  label="Overall Score"
                  color="black"
                  readonly
                ></v-text-field>
            </v-container>

              <v-container v-if="exam.exam_type === 'iTEP Academic' " class="pt-1 pb-0">
              <v-text-field
                  v-model="exam.itepAcademic_overall_score"
                  label="Overall Score"
                  color="black"
                  readonly
                ></v-text-field>
            </v-container>

            </v-card-text>
          </v-card>
        </v-container>
      <!-- Back Button -->
      </div>
    </div>
    <v-btn  class="mr-4 ml-2  fixed elevation-0" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>
  </div>

</template>

<script>
export default {
  data() {
    return {
      show: false,
      modal: false,
      alert: false,
      date2: "",
      drawer: false,
      menu2: false,
      editExamStatusDialog: false,
      editExamDateDialog: false,
      showAddScores: false,
      hideButton: true,
      gre_combined_score: '',
      gre_verbal_reasoning_score: '',
      gre_analytical_writing_score: '',
      gre_quantitative_reasoning_score: '',

      gre_verbal_percentile_score: '',
      gre_quantitative_percentile_score: '',
      gre_analytical_percentile_score: '',

    };
  },
  methods: {
    back() {
      if( window.innerWidth < 960 ) {
        this.$router.push('/dashboard/exams')
      } else {
        this.$router.push('/dashboard')
      }
    },
    showAddExamScoresPage (id) {

      this.$router.push('/dashboard/exams/addexamscores/' + id)
    },
    editExamScoresPage(id) {
      this.$router.push('/dashboard/exams/editexamscores/' + id)
    },
     saveStatus () {
      const statusData = {
        examId : this.id,
        examStatus : this.exam.examStatus
      }
      this.$store.dispatch('setUpdateExamStatus', statusData)
      this.editExamStatusDialog = false
     },
     editExamDate () {
        const dateData = {
        examId : this.id,
        date : this.exam.date
      }
       this.$store.dispatch('setUpdateExamDate', dateData)
       this.editExamDateDialog = false
     }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    user() {
      return this.$store.getters.user;
    },
    exam() {
      return this.$store.getters.examInfo(this.id);

    },

  },
   filters: {
      capitalizeString(string)

        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    },
};
</script>

<style scoped>

#schoolToolbar {
  position: sticky;
  box-shadow: 0 10px 30px -10px #11111130;

}
.closeButton {
  bottom: 0;
  top: 695px;
  background-color: white;
}



#buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.19);
}

  .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;

  }

 .card--flex-toolbar {
    margin-top: -64px;
  }
.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.wrap {
  margin-top: 8vh !important;
}


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Exams/ExamInfo.vue